import { createDownloader } from 'app/infrastructure/platform/browser';
import { connect } from 'react-redux';
import { endpoint as caseEndpoint } from 'app/area/case/endpoints';

export interface CaseLogDownloadContainerProps {  
  createDownloader?: (blobId: number, name: string) => Promise<void>;  
}

export const withCaseLogDownload = (component: any, uiEngineProps: any) => {
  
  const dispatchToProps = (): Partial<CaseLogDownloadContainerProps> => {
    const hostProps = uiEngineProps.hostProps();
    const isEditing = !!uiEngineProps.editing;
    const id = isEditing ? hostProps.entityId : hostProps.caseNumber;    
    const caseLogUrl = caseEndpoint.caseLog(isEditing, id);
    
    return {
      createDownloader: createDownloader(caseLogUrl)
    };
  };

  return connect<any, any, any>(dispatchToProps)(component);
};
